import {
    DatasetFilter,
    SiteHubGridData,
    SiteHubPanelScoreData,
    SiteHubWidgets,
    Widget,
} from '@interfaces/central-monitoring';
import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { getData, ValidationErrorResponse } from '@apis/rest-client';

const SiteHubApi = {
    useGetSitePanelsScoreData: (
        studyRef: string,
        datasetId: number,
        previousDatasetCount: number,
        datasetFilter: DatasetFilter,
        siteId?: number,
    ) => {
        return useSWRMutation<SiteHubPanelScoreData[], ValidationErrorResponse>(
            siteId
                ? `CentralMonitoring/Panels/${studyRef}/site-panel-scores/${datasetId}/${siteId}` +
                      `?previousDatasetCount=${previousDatasetCount}` +
                      `&datasetFilter=${datasetFilter}`
                : '',
            getData,
            {
                rollbackOnError: false,
            },
        );
    },

    useGetWidgets: (studyRef: string, datasetId?: number, siteId?: number, comparisonDatasetId?: number | null) => {
        const url =
            studyRef && datasetId && siteId
                ? comparisonDatasetId
                    ? `CentralMonitoring/sitewidgets/${studyRef}/${datasetId}/${siteId}?comparisonDatasetId=${comparisonDatasetId}`
                    : `CentralMonitoring/sitewidgets/${studyRef}/${datasetId}/${siteId}`
                : null;

        return useSWR<SiteHubWidgets, ValidationErrorResponse>(url, getData);
    },

    useGetSiteGridData: (studyRef: string, datasetId?: number, siteId?: number, comparisonDataSetId?: number) => {
        let url = null;

        if (datasetId && siteId) {
            url = `CentralMonitoring/Panels/${studyRef}/site-grid-data/${datasetId}/${siteId}`;

            if (comparisonDataSetId !== undefined) {
                url += `/${comparisonDataSetId}`;
            }
        }

        return useSWRMutation<SiteHubGridData[], ValidationErrorResponse>(url, getData);
    },
};

export default SiteHubApi;
